import React, { useState, useEffect } from 'react';
import { getMyProfile, addRoom, deleteRoom, setRoomAvailability } from '../../services/venueService';

const RoomManager = () => {
  const [profile, setProfile] = useState(null);
  const [newRoom, setNewRoom] = useState({ name: '', description: '', pricePerSession: '' });
  const [slotForm, setSlotForm] = useState({ roomId: '', date: '', time: '' });
  const [message, setMessage] = useState('');

  const refresh = () => getMyProfile().then(setProfile);

  useEffect(() => { refresh(); }, []);

  const handleAddRoom = async (e) => {
    e.preventDefault();
    const updated = await addRoom({ ...newRoom, pricePerSession: Number(newRoom.pricePerSession) });
    setProfile(updated);
    setNewRoom({ name: '', description: '', pricePerSession: '' });
  };

  const handleDeleteRoom = async (roomId) => {
    const updated = await deleteRoom(roomId);
    setProfile(updated);
  };

  const handleAddSlot = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await setRoomAvailability(slotForm.roomId, [{ date: slotForm.date, time: slotForm.time }]);
      setMessage('Slot added');
    } catch (err) {
      setMessage('Could not add slot');
    }
  };

  if (!profile) return <p>Loading...</p>;

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="font-semibold mb-3">Rooms</h3>
        <ul className="space-y-2 mb-4">
          {profile.rooms.map(room => (
            <li key={room._id} className="flex justify-between items-center border-b pb-2">
              <span>{room.name} — ₦{room.pricePerSession.toLocaleString()}</span>
              <button onClick={() => handleDeleteRoom(room._id)} className="text-red-600 text-sm">Remove</button>
            </li>
          ))}
          {profile.rooms.length === 0 && <p className="text-gray-500 text-sm">No rooms added yet</p>}
        </ul>
        <form onSubmit={handleAddRoom} className="flex flex-wrap gap-2">
          <input value={newRoom.name} onChange={(e) => setNewRoom({ ...newRoom, name: e.target.value })}
            placeholder="Room name" className="p-2 border rounded-lg flex-1" required />
          <input value={newRoom.pricePerSession} onChange={(e) => setNewRoom({ ...newRoom, pricePerSession: e.target.value })}
            placeholder="Price (₦)" type="number" className="p-2 border rounded-lg w-32" required />
          <button type="submit" className="bg-black text-white px-4 py-2 rounded-lg">Add room</button>
        </form>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="font-semibold mb-3">Add availability slot</h3>
        <form onSubmit={handleAddSlot} className="flex flex-wrap gap-2 items-center">
          <select value={slotForm.roomId} onChange={(e) => setSlotForm({ ...slotForm, roomId: e.target.value })}
            className="p-2 border rounded-lg" required>
            <option value="">Select room</option>
            {profile.rooms.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
          </select>
          <input type="date" value={slotForm.date} onChange={(e) => setSlotForm({ ...slotForm, date: e.target.value })}
            className="p-2 border rounded-lg" required />
          <input type="time" value={slotForm.time} onChange={(e) => setSlotForm({ ...slotForm, time: e.target.value })}
            className="p-2 border rounded-lg" required />
          <button type="submit" className="bg-black text-white px-4 py-2 rounded-lg">Add slot</button>
        </form>
        {message && <p className="text-sm text-green-600 mt-2">{message}</p>}
      </div>
    </div>
  );
};

export default RoomManager;
